import {
  ICustomerAccount,
  TPatchCustomerAccountRequestSchema,
} from "@zeal/common";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";

export const updateCustomerAccountInfo = (axios: IAxiosInstance) => {
  return async (
    body: Omit<TPatchCustomerAccountRequestSchema, "partner_id">
  ) => {
    const { customer_account_id, ...updates } = body;
    const response = await axios.noRetry.patch<IApiResponse<ICustomerAccount>>(
      `/customer-accounts/${customer_account_id}`,
      {
        ...updates,
        companyID: body.company_id,
      }
    );
    return response.data;
  };
};
